import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IOldNameControllingSubject } from 'APIPackage/KnmModule/interfaces/IOldNameControllingSubject';

export type OldNameControllingSubjectType = 'SUBJECT' | 'OBJECT';

export const formatChangeDate = (date?: string | null): string | null => {
  if (!date || date.length < 10) {
    return null;
  }

  return (
    formatDate({
      date: date.slice(0, 10),
      dateFormat: DATE_FORMAT_LONG_FNS,
      parseFormat: SYSTEM_DATE_FORMAT_FNS,
    }) || null
  );
};

export const buildNameChangeText = (
  oldName: string | null | undefined,
  newName: string | null | undefined,
  date: string | null | undefined,
): string | null => {
  const oldValue = oldName?.trim();
  const newValue = newName?.trim();
  const formattedDate = formatChangeDate(date);

  if (!oldValue || !newValue || !formattedDate || oldValue === newValue) {
    return null;
  }

  return `«${oldValue}» изменено на «${newValue}» ${formattedDate}`;
};

const getEntryName = (entry: IOldNameControllingSubject, type: OldNameControllingSubjectType): string | null => {
  const name = type === 'SUBJECT' ? entry.organizationName : entry.objectName;

  return name?.trim() || null;
};

interface IFindOldNameParams {
  oldNames: IOldNameControllingSubject[] | null | undefined;
  type: OldNameControllingSubjectType;
  guid?: string | null;
  currentCount?: number;
}

export interface IOldNameMatch {
  name: string;
  date: string | null;
}

export const findOldName = ({ oldNames, type, guid, currentCount }: IFindOldNameParams): IOldNameMatch | null => {
  const entries = (oldNames || []).filter(entry => entry?.type === type && !!getEntryName(entry, type));

  if (!entries.length) {
    return null;
  }

  const toMatch = (entry: IOldNameControllingSubject): IOldNameMatch => ({
    name: getEntryName(entry, type)!,
    date: entry.changeDate ?? null,
  });

  if (guid) {
    const matched = entries.find(entry => (entry.newGuid ?? entry.guid) === guid);

    if (matched) {
      return toMatch(matched);
    }
  }

  const isLegacySingle = currentCount === 1 && entries.length === 1 && !entries[0].newGuid;

  return isLegacySingle ? toMatch(entries[0]) : null;
};
